import { render, staticRenderFns } from "./BuildingShowDatesTab.vue?vue&type=template&id=5aca7b94"
import script from "./BuildingShowDatesTab.vue?vue&type=script&lang=ts"
export * from "./BuildingShowDatesTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports